import React from 'react';
import Card from '../../../../core/layout/Card';
import ContentVisualizationToggle from './ContentVisualizationToggle';
import ContentMasteryTestListScene from './ContentMasteryTestListScene';
import ContentMasteryTestChartScene from './ContentMasteryTestChartScene';

class ContentMasteryTestTab extends React.Component {
  state = {
    visualization: 'chart',
  };

  handleChangeVisualization = (value) => {
    this.setState({
      visualization: value,
    });
  };

  render() {
    return (
      <div>
        <Card
          actions={
            <ContentVisualizationToggle onChange={this.handleChangeVisualization} value={this.state.visualization} />
          }
        >
          {this.state.visualization === 'list' && <ContentMasteryTestListScene />}
          {this.state.visualization === 'chart' && <ContentMasteryTestChartScene />}
        </Card>
      </div>
    );
  }
}

export default ContentMasteryTestTab;
